export class OrderItemModel {
    id: number;
    ProductId: number;
    MedicationProductTitle: string;
    GenericName?: string;
    ItemId: number;
    ItemCode: string;
    Code: string;
    Quantity: number;
    ItemUnitId: number | null;
    FrequencyId: number | null;
    DefaultUnitGroupId: number | null;
    availableUnits: { label: string; value: number }[];
    Price: number;
    Net: number;
    Stock: number;
    ExpiryDate: string | null;
    isLoadingPrice: boolean;
    isLoadingStock: boolean;
    isLoadingUnits: boolean;
    priceError: boolean;
    priceValidationFailed: boolean;
    priceValidationMessage?: string;
    priceValidationWarning?: boolean;
    stockWarning: boolean;
    stockError: boolean;
    stockFetchError: boolean;
}